import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import VendorNav from './VendorNav';
import BackgroundImage from '../../../assets/VendorHeroBackground.png';

const VendorHero = () => {
    const navigate = useNavigate();
    const [navbarColor, setNavbarColor] = useState('transparent');
    const vendorPromisesRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (vendorPromisesRef.current) {
                const vendorPromisesTop = vendorPromisesRef.current.getBoundingClientRect().top;
                if (vendorPromisesTop <= 0) {
                    setNavbarColor('#26051C');
                } else {
                    setNavbarColor('transparent');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div
            className="w-full bg-cover bg-left-top md:bg-right 2xl:bg-right-bottom h-fit min-h-screen flex flex-col justify-center 1.5xl:px-[104px]"
            style={{backgroundImage: `url(${BackgroundImage}), url(https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/Homepage/VendorHeroBackground.png)`}}>

            <div className="fixed top-0 left-0 right-0 z-50">
                <VendorNav navbarColor={navbarColor} />
            </div>

            <div className="1.5xl:mt-[20px] w-full h-full flex flex-col justify-center px-basePx xs:px-xsPx 1.5xl:px-0">
                <h1 className="w-full md:w-[40rem] lg:w-[48rem] 1.5xl:w-[45rem] 2.5xl:w-[80rem] mb-0 text-left text-white text-[44px] sm:text-[45px] lg:text-[60px] 1.5xl:text-[80px] 2.5xl:text-[116px] font-allroundgothic font-[600]" ref={vendorPromisesRef}>
                    Become Our Partner in Care
                </h1>

                <p className="mb-0 md:w-[45rem] lg:w-[50rem] 1.5xl:w-[48rem] 2xl:w-[60rem] mt-[32px] xs:mt-[40px] 2.5xl:mt-[80px] text-left text-white text-[18px]  font-proximanova">CharmHealthHub is a health I.T. marketplace that connects a thriving ecosystem of providers and patients with the latest in healthcare innovaiton. If you have a product or solution that can make the delivery of care a little smoother, join CharmHealthHub today and help us bring the best healthcare solutions to our providers.</p>

                <div className="w-full">
                    <button className="w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova mt-8 xs:mt-10 px-8 py-2 1.5xl:px-10 1.5xl:py-4"
                        onClick={() => navigate('/vendors/signup')}>
                        Register as a Vendor
                    </button>
                </div>
            </div>
        </div >
    );
}

export default VendorHero;